export enum Breakpoint {
  MOBILE_DOWN = '(max-width: 575px)',
  TABLET_UP = '(min-width: 576px)',
  TABLET_DOWN = '(max-width: 991px)',
  TABLET_SM_ONLY = '(min-width: 576px) and (max-width: 767px)',
  TABLET_LG_ONLY = '(min-width: 768px) and (max-width: 991px)',
  TABLET_LG_UP = '(min-width: 768px)',
  DESKTOP_UP = '(min-width: 992px)',
  DESKTOP_MD_UP = '(min-width: 1200px)',
  DESKTOP_MD_DOWN = '(max-width: 1200px)',
}

export enum NewBreakpoint {
  mobile_down = '(max-width: 575px)',
  mobile_only = '(max-width: 575px)',

  xxs_up = '(min-width: 576px)',
  xxs_down = '(max-width: 767px)',
  xxs_only = '(min-width: 576px) and (max-width: 767px)',

  xs_up = 'screen and (min-width: 768px)',
  xs_down = '(max-width: 991px)',
  xs_only = '(min-width: 768px) and (max-width: 991px)',

  sm_up = '(min-width: 992px)',
  sm_down = '(max-width: 1199px)',
  sm_only = '(min-width: 992px) and (max-width: 1199px)',

  md_up = '(min-width: 1200px)',
  md_down = '(max-width: 1439px)',
  md_only = '(min-width: 1200px) and (max-width: 1439px)',

  lg_up = '(min-width: 1440px)',
  lg_down = '(max-width: 1679px)',
  lg_only = '(min-width: 1440px) and (max-width: 1679px)',

  xl_up = '(min-width: 1680px)',
  xl_only = '(min-width: 1680px)',
}
